<template>
    <svg :id="bid" ref="barChart"></svg>
</template>
<script>
/* eslint-disable */
// eslint-disable-next-line
import * as d3 from "d3";
export default {
  props: {
    bid: String,
    data: Object
  },
  data () {
    return {
      //
    }
  },
  mounted() {
      this.generateBarChart()
  },
  methods: {
      generateBarChart () {
          console.log('enter');
          // options
            var w = this.$refs.barChart.clientWidth;
            var h = this.$refs.barChart.clientWidth * 0.5;
            var colors={"Type A": "#d8ebf9", "Type B": "#afd7f1", "Type C": "#7abdea"}
            console.log(this.data, 'in')
            // data
            var data = this.data ? this.data.list : [];
            
            const svg = d3.select("svg#"+this.bid),
            margin = {top: 0, right: -5, bottom: 30, left: 15}, 
            width = w - margin.left - margin.right, 
            height = h - margin.top - margin.bottom, 
            x = d3.scaleBand().rangeRound([0, width]).padding(0.4), 
            y = d3.scaleLinear().rangeRound([height, 0]), 
            g = svg.append("g") 
            .attr("transform", `translate(${margin.left},${margin.top})`); 
            x.domain(data.map(d => d.genre)); 
            y.domain([0, d3.max(data, d => d.count)]); 
            svg.attr("viewBox", `0 0 ${w} ${h}`);
            g.append("g") 
            .attr("class", "axis axis-x") 
            .attr("transform", `translate(0,${height})`) 
            .call(d3.axisBottom(x)); 

            g.append("g") 
            .attr("class", "axis axis-y") 
            .call(d3.axisLeft(y).tickSize(-width).ticks(5)); 

            g.selectAll(".bar") 
            .data(data) 
            .enter().append("rect") 
            .attr("class", "bar") 
            .attr("x", d => x(d.genre)) 
            .attr("y", d => y(d.count)) 
            .attr("width", x.bandwidth()) 
            .attr("height", d => height - y(d.count))
            .attr("fill",  d => colors[d.genre]);

            var texts = g.selectAll(".myTexts")
                        .data(data)
                        .enter()
                        .append("text");
            texts.attr('x', (a) => x(a.genre) + x.bandwidth() / 2)
            .attr('y', (a) => y(a.count) + 15)
            .attr('text-anchor', 'middle')
            .text(d => d.count)
            .style('font-size', '12px')
            .style('font-weight', 'bold')
            .style('opacity', (d) => d.count >0 ? 1 : 0);

            g.select(".axis-y .domain").remove();
            g.select(".axis-x .domain").remove();
            g.selectAll(".axis-x .tick line").style('opacity', 0.5);
            g.selectAll(".axis-y .tick text").remove();
            g.selectAll(".axis-x .tick text").style('fill', "#656565");
      }
  }
}
</script>
<style>
svg line {
    stroke: #dedede;
}
</style>


// WEBPACK FOOTER //
// src/components/core/BarChart.vue